import { useWatch } from 'react-hook-form';
import { BooksClosedBanner } from '../../../../components';
import { useExpenseForm } from '../useExpenseForm';

export const ExpenseBooksClosedBanner = () => {
  const methods = useExpenseForm();

  const date = useWatch({
    control: methods.control,
    name: 'date',
  });

  return <BooksClosedBanner date={date} />;
};
